<app-header />
<main class="flex-column">
  <router-outlet />
</main>
<app-footer />
